(function ($) {
  let loading = false;

  $(document).mouseup(function (e) {
    var container = $(".c-downloadscenter__items-list");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.c-downloadscenter__language-wrap').hide();
    }
  });

  $(document).on('click', '.c-downloadscenter__item-row', function () {
    $('.c-downloadscenter__language-wrap').hide();
    let links = $(this).find('.c-downloadscenter__language-wrap');
    $(links).toggle();
  });

  let downloadsCenters = document.querySelectorAll('.c-downloadscenter');
  downloadsCenters.forEach(function (e) {
    $(e).on('change', '.c-downloadscenter__filter-dropdown', function () {
      $('input[name="tx_hbdownloadscenter_list[filters][nextPage]"]').val(1);
      loading = true;
      submitDownloadsCenterForm(e);
    });

    $(e).on('click', '.c-downloadscenter__reset', function () {
      $(e).find('.c-downloadscenter__filter-dropdown').val('');
      submitDownloadsCenterForm(e);
    });

    $(e).on('click', '.c-downloadscenter__load-more', function () {
      let element = $(e).find('.downloadscenter-entries')[0];
      if ($(element).length > 0) {
        let items = $(element).find('.c-downloadscenter__item-row').length;
        let nextPage = $($(e).find('input[name="tx_hbdownloadscenter_list[filters][nextPage]"]')[0]).val();
        let itemsPerPage = $($(e).find('input[name="tx_hbdownloadscenter_list[filters][itemsPerPage]"]')[0]).val();
        if (!loading && (items >= ((nextPage - 1) * itemsPerPage))) {
          loading = true;
          submitDownloadsCenterForm(e);
        }
      }
    });
  });

  $(document).on('click', '.file-download-dropdown', function (e) {
    e.preventDefault();
    let languageSelector = $(this).parent().find('.c-downloads__language-wrap');

    if (languageSelector.length > 0) {
      languageSelector.slideDown('fast');
      return false;
    }
  });

  $(document).mouseup(function (e) {
    if ($(e.target).closest('.c-downloads__language-wrap').length === 0) {
      $('.c-downloads__language-wrap').hide();
    }
  });

  $(document).on('mouseleave', '.c-downloads__options', function () {
    $(this).find('.c-downloads__language-wrap').slideUp('fast');
  });

  $(document).on('mouseleave', '.c-downloadscenter__links-wrap', function () {
    $(this).find('.c-downloadscenter__language-wrap').hide();
  });

  function submitDownloadsCenterForm(e) {
    $('.o-page__overlay').toggleClass('o-page__overlay--for-loading');
    let form = $(e).find('.downloads-filter-form')[0];
    let entries = $(e).find('.downloadscenter-entries')[0];

    $.ajax({
      type: 'GET',
      url: downloadsFilterUrl,
      data: $(form).serializeArray(),
      success: function (data) {
        $(entries).html(data);
        $('.o-page__overlay').toggleClass('o-page__overlay--for-loading');
        loading = false;
      }
    });
  }

})(jQuery);
